<div class="login-page" [style.background-image]="'url(' + bgLoginPath + ')'">
  <div class="login-page__container">
    <div class="login-card confirm-contact-card">
      <div class="login-card__header">
        <img src="assets/icon/logo-sso.png" alt="Cổng xác thực tập trung" class="login-card__logo">
        <h1 class="login-card__title">Cập nhật thông tin liên hệ</h1>
        <p class="login-card__subtitle">
          Vui lòng kiểm tra và cập nhật email cá nhân và số điện thoại
          (bắt buộc mỗi 6 tháng)
        </p>
      </div>

      <nz-spin [nzSpinning]="isLoading">
        <div class="contact-meta" *ngIf="fullName || contactEmail">
          <p *ngIf="fullName"><span>Họ tên:</span> {{ fullName }}</p>
          <p *ngIf="contactEmail"><span>Email hệ thống:</span> {{ contactEmail }}</p>
        </div>

        <form [formGroup]="form" class="login-card__form" (ngSubmit)="submitUpdate()">
          <div class="login-field">
            <hbt-input-text
              class="login-input"
              [defaultInput]="true"
              labelText="Email cá nhân (thường sử dụng) <span class='label__required'>*</span>"
              placeholderText="Nhập email cá nhân"
              formControlName="personalEmail"
              [required]="true"
              [type]="isSubmitted && f['personalEmail'].errors ? 'error' : 'default'"
              [showError]="isSubmitted && f['personalEmail'].errors !== null"
              [errors]="f['personalEmail'].errors"
              [errorDefs]="[
                { errorName: 'required', errorDescription: 'Bắt buộc nhập email cá nhân' },
                { errorName: 'email', errorDescription: 'Email không hợp lệ' }
              ]">
            </hbt-input-text>
          </div>

          <div class="login-field">
            <hbt-input-text
              class="login-input"
              [defaultInput]="true"
              labelText="Số điện thoại <span class='label__required'>*</span>"
              placeholderText="Nhập số điện thoại"
              formControlName="mobileNumber"
              [required]="true"
              [type]="isSubmitted && f['mobileNumber'].errors ? 'error' : 'default'"
              [showError]="isSubmitted && f['mobileNumber'].errors !== null"
              [errors]="f['mobileNumber'].errors"
              [errorDefs]="[
                { errorName: 'required', errorDescription: 'Bắt buộc nhập số điện thoại' },
                { errorName: 'pattern', errorDescription: 'Số điện thoại không hợp lệ' }
              ]">
            </hbt-input-text>
          </div>

          <div class="otp-row" *ngIf="needOtp">
            <button type="button" class="otp-btn" nz-button [disabled]="isLoading" (click)="sendOtp()">
              {{ otpSent ? 'Gửi lại OTP' : 'Gửi OTP' }}
            </button>
            <span class="otp-hint" *ngIf="otpSent">Đã gửi tới {{ maskedOtpEmail }} ({{ otpDuration }}s)</span>
          </div>

          <div class="login-field" *ngIf="needOtp && otpSent">
            <hbt-input-text
              class="login-input"
              [defaultInput]="true"
              labelText="Mã OTP <span class='label__required'>*</span>"
              placeholderText="Nhập mã 6 số"
              formControlName="otpCode"
              [type]="isSubmitted && f['otpCode'].errors ? 'error' : 'default'"
              [showError]="isSubmitted && f['otpCode'].errors !== null"
              [errors]="f['otpCode'].errors"
              [errorDefs]="[{ errorName: 'required', errorDescription: 'Bắt buộc nhập mã OTP khi đổi email cá nhân' }]">
            </hbt-input-text>
          </div>

          <button type="submit" class="login__btn" nz-button [disabled]="isLoading">Lưu và tiếp tục</button>
          <div class="login-links">
            <a (click)="logout()" class="login-links__item">Đăng xuất</a>
          </div>
        </form>
      </nz-spin>

      <p class="login-card__footer">
        © 2026 • Cổng xác thực tập trung • Cổng đăng nhập SSO
      </p>
    </div>
  </div>
</div>
